var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcBtnAdd = function SvgIcBtnAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 2.667a.75.75 0 1 0-1.5 0V7.25H2.665a.75.75 0 1 0 0 1.5h4.583v4.583a.75.75 0 0 0 1.5 0V8.75h4.584a.75.75 0 0 0 0-1.5H8.749V2.667Z"
  })));
};
export default SvgIcBtnAdd;